import { useMemo } from 'react';
import { useApp } from '@context/AppContext';
import { useRouter } from 'next/router';

export function useContextOrganizationId(orgIdOverride = '') {
  const { user } = useApp();
  const router = useRouter();

  const organizationId = useMemo(() => {
    let organizationId =
      orgIdOverride ||
      ((router.query.organizationId as string) ?? user?.organizationId);

    if (organizationId === '~') {
      organizationId =
        user?.permissions.find(
          (permission) =>
            permission.entityType === 'Organization' &&
            permission.entityId === user?.organizationId
        )?.entityNameId ?? user?.organizationId;
      const newPath = router.asPath.replace('/~', `/${organizationId}`);
      router.replace(newPath);
      return organizationId;
    }

    return organizationId;
  }, [orgIdOverride, router, user?.organizationId, user?.permissions]);

  return organizationId;
}
